import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Button } from './Button';
import ShieldIcon from '@mui/icons-material/Shield';
import LockIcon from '@mui/icons-material/Lock';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import BoltIcon from '@mui/icons-material/Bolt';
export function PricingSection() {
  return <SectionWrapper className="bg-secondary" data-id="element-180">
      <div className="max-w-xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden border-2 border-primary" data-id="element-181">
        <div className="bg-primary text-white p-6 text-center" data-id="element-182">
          <h2 className="font-serif text-2xl font-bold mb-2" data-id="element-183">
            REINICIO INTERNO™ — KIT COMPLETO
          </h2>
          <p className="text-primary-dark text-sm font-medium opacity-90" data-id="element-184">
            Reset Digestivo + 5 Bonos · Método META + MACA completo
          </p>
        </div>

        <div className="p-8 text-center" data-id="element-185">
          <div className="flex justify-center items-center gap-4 mb-6" data-id="element-186">
            <span className="text-2xl text-gray-400 line-through font-bold" data-id="element-187">
              $66.000
            </span>
            <span className="text-5xl font-bold text-gray-900" data-id="element-188">
              $19.990 <span className="text-xl text-gray-500" data-id="element-189">ARS</span>
            </span>
          </div>

          <Button fullWidth className="mb-6 py-5 text-xl" data-id="element-190">
            🟢 → QUIERO MI REINICIO INTERNO AHORA
          </Button>

          <div className="grid grid-cols-2 gap-4 text-sm text-gray-600 bg-gray-50 p-4 rounded-xl" data-id="element-191">
            <div className="flex items-center justify-center" data-id="element-192">
              <LockIcon fontSize="small" className="mr-2 text-primary" data-id="element-193" /> Pago
              100% seguro
            </div>
            <div className="flex items-center justify-center" data-id="element-194">
              <BoltIcon fontSize="small" className="mr-2 text-amber-500" data-id="element-195" />{' '}
              Acceso en 5 minutos
            </div>
            <div className="flex items-center justify-center" data-id="element-196">
              <ShieldIcon fontSize="small" className="mr-2 text-primary" data-id="element-197" />{' '}
              Garantía 7 días
            </div>
            <div className="flex items-center justify-center" data-id="element-198">
              <CreditCardIcon fontSize="small" className="mr-2 text-primary" data-id="element-199" />{' '}
              M. Pago · Tarjeta · Transf.
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}